<script lang="ts">
  import {tooltip} from '@/actions/tippy-action';
  import {onDestroy} from 'svelte';
  import editorInstance from '../../editor';
  import editorStore from '../../editor.store';

  let fontSize = 16;
  let lineHeight = 16;
  let targetElement: HTMLElement;
  const unsubscribe = editorStore.subscribe(store => {
    if (store.activeComponent) {
      targetElement = store.activeComponent.querySelector('.dynamic') as HTMLElement;
      if (!targetElement) return;
      fontSize = Number.parseInt(targetElement.style.fontSize);
      lineHeight = Number.parseInt(targetElement.style.lineHeight);
    }
  });

  const incFontSize = () => {
    console.log('increase font size', targetElement);
    fontSize++;
    if (targetElement) targetElement.style.fontSize = fontSize + 'px';
    editorInstance.history.addHistory('Increase Font Size');
  };

  const decFontSize = () => {
    console.log('decrease font size', targetElement);
    fontSize--;
    if (targetElement) targetElement.style.fontSize = fontSize + 'px';
    editorInstance.history.addHistory('Decrease Font Size');
  };

  const incLineHeight = () => {
    lineHeight++;
    if (targetElement) targetElement.style.lineHeight = lineHeight + 'px';
    editorInstance.history.addHistory('Increase Line Height');
  };

  const decLineHeight = () => {
    lineHeight--;
    if (targetElement) targetElement.style.lineHeight = lineHeight + 'px';
    editorInstance.history.addHistory('Decrease Line Height');
  };

  onDestroy(unsubscribe);
</script>

<div class="flex flex-row">
  <i use:tooltip={'Font Size'} class="fa-regular fa-text-size my-auto mr-2"></i>
  <div class="flex rounded-lg border border-gray-300 bg-white">
    <button
      type="button"
      class="flex cursor-pointer select-none items-center rounded-l-md px-2 text-gray-400 hover:bg-gray-100"
      on:click={decFontSize}
      on:keydown={decFontSize}
    >
      -
    </button>
    <input
      type="number"
      class="w-8 flex-grow text-ellipsis border-0 p-0 text-center font-bold focus:outline-none focus:ring-0"
      contenteditable="true"
      bind:value={fontSize}
      on:change={() => {
        if (targetElement) targetElement.style.fontSize = fontSize + 'px';
      }}
    />
    <button
      type="button"
      class="flex cursor-pointer select-none items-center rounded-r-md px-2 text-gray-400 hover:bg-gray-100"
      on:click={incFontSize}
      on:keydown={incFontSize}
    >
      +
    </button>
  </div>

  <div class="border-1 mx-2 my-auto h-6 border-l border-gray-300"></div>

  <i use:tooltip={'Line Height'} class="fa-regular fa-line-height my-auto mr-2"></i>
  <div class="flex rounded-lg border border-gray-300 bg-white">
    <button
      type="button"
      class="flex cursor-pointer select-none items-center rounded-l-md px-2 text-gray-400 hover:bg-gray-100"
      on:click={decLineHeight}
      on:keydown={decLineHeight}
    >
      -
    </button>
    <input
      type="number"
      class="w-8 flex-grow text-ellipsis border-0 p-0 text-center font-bold focus:outline-none focus:ring-0"
      contenteditable="true"
      bind:value={lineHeight}
      on:change={() => {
        if (targetElement) targetElement.style.lineHeight = lineHeight + 'px';
      }}
    />
    <button
      type="button"
      class="flex cursor-pointer select-none items-center rounded-r-md px-2 text-gray-400 hover:bg-gray-100"
      on:click={incLineHeight}
      on:keydown={incLineHeight}
    >
      +
    </button>
  </div>
</div>

<style>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
</style>
